import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, combineLatest, Subject, Subscription } from 'rxjs';
import { debounceTime, filter, startWith, switchMap, take, takeUntil } from 'rxjs/operators';
import { PaginationPage, PaginationResponse } from 'src/app/classes';
import { Location } from '../../../classes';
import { LocationService } from '../../../services/location.service';

@Component({
  selector: 'app-select-location-dialog',
  templateUrl: './select-location-dialog.component.html',
  styleUrls: ['./select-location-dialog.component.css']
})
export class SelectLocationDialogComponent implements OnInit {

  locations: Location[] = [];

  formControl: FormControl = new FormControl();

  page: PaginationPage = { 'pageNumber': 1, 'pageSize': 20 };

  total: number = 0;

  private _searching = new BehaviorSubject(false);
  private _searchImmediately = new Subject<void>();
  private _subscriptions: Subscription[] = [];

  constructor(
    private _dialogRef: MatDialogRef<SelectLocationDialogComponent>,
    private _locationService: LocationService
  ) { }

  close(){
    this._dialogRef.close();
  }
  
  loadMore(){
    if(!this._searching.value && this.total > this.locations.length){
      this.page.pageNumber++;
      this._searching.next(true);
      this._locationService
        .searchLocationsByString(this.formControl.value, this.page)
        .subscribe((result) => this.searchCallback(result));
    }
  }

  locationClicked(location: Location){
    this._dialogRef.close(location);
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.setInitialLocations();
    this.locations = [];
    this._subscriptions.push(...[
      combineLatest([this.formControl.valueChanges.pipe(debounceTime(500)), this._searchImmediately.pipe(startWith([]))]).pipe(filter(_ => !this._searching.value), switchMap(([search]) => {
        this.total = 0;
        this.page.pageNumber = 1;
        this._searching.next(true);
        return this._locationService.searchLocationsByString(search, this.page);
      })).subscribe((result: PaginationResponse<Location[]>) => this.searchCallback(result))
    ])
  }

  search = () => this._searchImmediately.next();
  searchCallback = (result: PaginationResponse<Location[]>) => {
    if(this.page.pageNumber === 1) this.locations = [];
    this.locations.push(...result.content);
    this.total = result.totalItems;
    this._searching.next(false);
  };

  setInitialLocations(){
    this._locationService.locations$.pipe(take(1), takeUntil(this._searching.pipe(filter(x => x)))).subscribe((locations: Location[]) => this.locations = locations as any);
  }

}
